import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import Icon24 from 'builder/components/Icon'

import { InfoBox, SuccessBox } from '../../'
import { WidgetBox, WidgetContainer } from '../../widget.styles'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'

import { useThemeConfig } from '../../hooks/useThemeConfig'
import { useFirst90DaysPlanConfig } from './hooks/useFirst90DaysPlanConfig'

import { ActionButtons } from './ActionButtons'
import * as Styles from './styles'

import AnimationVideo from './assets/coaches.webm'
import AnimationVideoMobile from './assets/coaches-mobile.webm'
import ProgressImage from './assets/ilustration.png'
import ProgressMobileImage from './assets/ilustration-mobile.png'

export const First90DaysPlan = ({ service }: WidgetProps) => {
  const { isPhone } = useMediaQueries()
  const theme = useThemeConfig({ service })
  const { text, status, steps, handleCloseModal } = useFirst90DaysPlanConfig(service)

  const src = isPhone ? ProgressMobileImage : ProgressImage
  const animationSrc = isPhone ? AnimationVideoMobile : AnimationVideo

  const animationComponent = () => {
    if (status === 'completed') return <SuccessBox />
    if (status === 'progress') return <Styles.Image src={src} />

    return (
      <Styles.AnimationVideoContainer>
        <Styles.AnimationVideo src={animationSrc} autoPlay muted loop playsInline />
      </Styles.AnimationVideoContainer>
    )
  }

  return (
    <WidgetTheme theme={theme[status]} tipOrder={0}>
      {status === 'initial' && (
        <Styles.CloseButton onClick={handleCloseModal}>
          <Icon24.Close />
        </Styles.CloseButton>
      )}
      <WidgetContainer>
        <WidgetBox>
          <InfoBox text={text} isCompleted={status === 'completed'}>
            <ActionButtons status={status} text={text} steps={steps} />
          </InfoBox>
        </WidgetBox>
        <WidgetBox>{animationComponent()}</WidgetBox>
      </WidgetContainer>
    </WidgetTheme>
  )
}
